import React from 'react';
import { styled } from '@mui/material/styles';

import Button from '@mui/material/Button';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import { isMobile } from '../../utils';
import Menu from './Menu/Menu';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { Typography, Grid, Box } from '@mui/material';
import ToggleAudioButton from '../Buttons/ToggleAudioButton/ToggleAudioButton';
import ToggleChatButton from '../Buttons/ToggleChatButton/ToggleChatButton';
import ToggleParticipantButton from '../Buttons/ToggleParticipantButton/ToggleParticipantButton';
import ToggleVideoButton from '../Buttons/ToggleVideoButton/ToggleVideoButton';
import ToggleScreenShareButton from '../Buttons/ToogleScreenShareButton/ToggleScreenShareButton';
import { useAppState } from '../../state';
import InviteButton from '../CallInvite/InviteButton';
import TroubleshootButton from '../Buttons/TroubleshootButton';

const Footer = styled('footer')(({ theme }) => ({
  gridArea: '1 / 1 / 2 / 3',
  backgroundColor: '#191b1d',
  bottom: 0,
  left: 0,
  right: 0,
  height: `${theme.footerHeight}px`,
  position: 'fixed',
  display: 'flex',
  padding: '0 1.43em',
  zIndex: 10,
  [theme.breakpoints.down('sm')]: {
    height: `${theme.mobileFooterHeight}px`,
    padding: 0,
  },
}));

const ScreenShareBanner = styled(Grid)(({ theme }) => ({
  position: 'fixed',
  zIndex: 8,
  bottom: `${theme.footerHeight}px`,
  left: 0,
  right: 0,
  height: '104px',
  background: 'rgba(0, 0, 0, 0.5)',
  '& h6': {
    color: 'white',
  },
  '& button': {
    background: 'white',
    color: theme.brand,
    border: `2px solid ${theme.brand}`,
    margin: '0 2em',
    '&:hover': {
      color: '#600101',
      border: `2px solid #600101`,
      background: '#FFE9E7',
    },
  },
}));

const ButtonContainer = styled(Grid)({
  flexWrap: 'nowrap',
});

const InviteLinkContainer = styled(Grid)({
  '& a': {
    color: 'white',
  },
});

export default function MenuBar() {
  const { isSharingScreen, toggleScreenShare } = useVideoContext();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const { meeting } = useAppState();
  console.log(meeting, '1111');
  return (
    <>
      {isSharingScreen && (
        <ScreenShareBanner container justifyContent="center" alignItems="center">
          <Typography variant="h6">You are sharing your screen</Typography>
          <Button onClick={() => toggleScreenShare()}>Stop Sharing</Button>
        </ScreenShareBanner>
      )}
      <Footer>
        <Grid container justifyContent="space-around" alignItems="center" sx={{ width: '100%' }}>
          <Box sx={{ display: { xs: 'none', sm: 'block' }, flex: 1 }}>
            <InviteLinkContainer container justifyContent="flex-start">
              <TroubleshootButton />
            </InviteLinkContainer>
          </Box>
          <Grid>
            <ButtonContainer container justifyContent="center">
              <ToggleAudioButton disabled={isReconnecting} />
              {meeting?.is_anonymous === false && <ToggleVideoButton disabled={isReconnecting} />}
              {meeting &&
                !meeting.disabled_screen_share &&
                Boolean(meeting.isChaperoning) !== true &&
                !isSharingScreen &&
                !isMobile && <ToggleScreenShareButton disabled={isReconnecting} />}
              {process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && meeting?.is_chat === true && (
                <ToggleChatButton />
              )}
              <ToggleParticipantButton />
              <EndCallButton />
              <Menu />
            </ButtonContainer>
          </Grid>
          <Box sx={{ display: { xs: 'none', sm: 'block' }, flex: 1 }}>
            <InviteLinkContainer container justifyContent="flex-end">
              <InviteButton />
            </InviteLinkContainer>
          </Box>
        </Grid>
      </Footer>
    </>
  );
}
